<template>
  <Select name="lang" id="lang" v-model="lang" icon="select" rightSpan="12px">
    <!-- <option value="en-US">English</option>
        <option value="zh-CN">简体中文</option>
        <option value="es-ES">Español</option>
        <option value="tr-TR">Türkçe</option>
        <option value="zh-TW">繁體中文</option>
        <option value="fr-FR">Français</option>
        <option value="pt-PT">Portuguese</option>
        <option value="vi-VN">Tiếng việt </option>
        <option value="th-TH">ไทย</option>
        <option value="ja-JP">日本語</option>
        <option value="ko-KR">한국어</option>
        <option value="ar-AR">العربية</option>
        <option value="ru-RU">Россия</option>
        <option value="de-DE">Deutsch</option> -->
    <option v-for="(text, langVal) in langList" :key="langVal" :value="langVal">
      {{ text }}
    </option>
  </Select>
</template>
<script>
import { SWITCH_PASSPORT_LANG } from '../../store/passport/accountSetting';
import { SWITCH_LANG } from '../../store/support/event-type.js';
import { mapState } from 'vuex';
export default {
  name: 'select-lang',
  props: {
    isPassport: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      lang: '',
    };
  },
  computed: {
    ...mapState({
      globalLang: state => state.support.language,
    }),
    langList() {
      return this.$store.state.support.langList;
    },
  },
  created: function () {
    this.lang = this.globalLang;
  },
  watch: {
    lang: function (newVal) {
      let type = this.isPassport ? SWITCH_PASSPORT_LANG : SWITCH_LANG;
      this.$store.commit(type, newVal);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
#lang {
  @include size(130, 39);
  padding-left: 11px;
  color: $green;
  font-size: 18px;
  @include bgC(rgba(0, 0, 0, 0));
  border: solid 1px #5fd193;
}
@media screen and (orientation: portrait) {
}

@media screen and (orientation: landscape) {
}
</style>
